// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"9":"ddf35e0f","11":"ddf35e0f","14":"81763ff8","39":"ddf35e0f","53":"ef2c189e","264":"f6a272f6","677":"1dbd9393","717":"db648f96"}[chunkId] + ".chunk.css";
};